import { IXBaseSDKErrorInfo } from './types/xbase'
import { THeZiProps, ICommonError } from './types/android'
type TFuncNames = THeZiProps
/** 单向调用方法名称列表（即无任何参数的函数调用） */
const onewayCallFuncName: TFuncNames[] = ['closeApp', 'finish', 'getDisplayInfo', 'hideHeziPathSelector']

function request (url: string, method: 'POST' | 'GET', data: string | undefined | null, contentType: string, callbackId: string) {
  if (!window?.HeZi?.request) {
    return Promise.reject(new Error('request function not exist in HeZi'))
  }
  return window.HeZi.request(url, method, data, contentType, callbackId)
}

function checkFunction (funcName: TFuncNames) {
  if (!window.HeZi?.[funcName]) return false
  return true
}

interface IRequestInfo {
  url: string
  method: 'GET' | 'POST'
  data?: string | null
  contentType?: string
}
export interface IXBaseRequestInfo {
  url: string
  method: 'GET' | 'POST' | 'PATCH' | 'DELETE'
  data?: object
  contentType?: string
  /** 是否进行客户端注入变量，详见IHeziXBaseRequestInfo */
  inject?: boolean
}
interface IBridgeResponse<T = any> {
  success?: T
  error?: IXBaseSDKErrorInfo | ICommonError
  /** 客户端只透传调用结果，不对结果是否成功做判断 */
  result?: T
}
interface IXBaseCaptchaTokenParams {
  /** 待验证的链接，如`PATCH:/v1/user/password` */
  action: string
  /** 验证过期是否重启验证 */
  force: boolean
  /** 业务附加参数，会原文返回，最多添加8个meta字段 */
  meta?: object
}
type FBridgeCallback<T = any> = (err: IBridgeResponse['error'] | null, data?: IBridgeResponse<T>['success']) => void
const bridge = {
  uniqueId: 1,
  get isAndroidNative () {
    return !!window?.HeZi
  },
  genCallbackFunction: <T = any>(tag: string, callback: FBridgeCallback<T>) => {
    const responseCallbackId = `${tag}_${bridge.uniqueId++}_${new Date().getTime()}`

    window[responseCallbackId] = function responseCallback (response: IBridgeResponse) {
      // console.log(`[AndroidBridge][${responseCallbackId}]:`, response)
      if (!response) {
        callback(null, response)
      } else if (response.error) {
        callback(response.error)
      } else if (response.success) {
        callback(null, response.success)
      } else if (response.result) {
        if (response.result.error) {
          callback(response.result)
        } else {
          callback(null, response.result)
        }
      } else {
        callback(null, response as T)
      }

      delete window[responseCallbackId]
    }

    return responseCallbackId
  },
  // caches: {},
  request: function <T = any> (info: IRequestInfo, callback: FBridgeCallback<T>) {
    const responseCallbackId = bridge.genCallbackFunction('request', callback)
    const { url, method, data, contentType = 'application/json' } = info
    request(url, method, data, contentType, responseCallbackId)
  },
  /** 调用第三方授权、获取第三方登录绑定的token */
  xbaseAuth: function (provider: { id: string }, callback: FBridgeCallback<{ provider_token: string }>) {
    const responseCallbackId = bridge.genCallbackFunction('xbase_auth', callback)
    const $native = window?.HeZi
    if (!$native?.xbaseRequest) {
      throw new Error('request function not exist in HeZi')
    }
    $native.xbaseAuth(JSON.stringify({ id: provider.id }), responseCallbackId)
  },
  /** Android端进行xbase请求封装函数 */
  xbaseRequest: function <T = any> (info: IXBaseRequestInfo, callback: FBridgeCallback<T>) {
    const responseCallbackId = bridge.genCallbackFunction('xbase_request', callback)
    const { data: body, ...other } = info
    const $native = window?.HeZi
    if (!$native?.xbaseRequest) {
      throw new Error('xbaseRequest function not exist in HeZi')
    }
    $native.xbaseRequest(JSON.stringify({ body, ...other }), responseCallbackId)
  },
  xbaseRequireCaptchaToken: function (info: IXBaseCaptchaTokenParams, callback: FBridgeCallback<{ captcha_token: string }>) {
    const responseCallbackId = bridge.genCallbackFunction('xbase_captcha_init', callback)
    const $native = window?.HeZi
    if (!$native?.xbaseRequireCaptchaToken) {
      throw new Error('xbaseRequireCaptchaToken function not exist in HeZi')
    }
    $native.xbaseRequireCaptchaToken(JSON.stringify(info), responseCallbackId)
  },
  callHandler: function <T = any> (funcName: TFuncNames, params?: any, callback?: FBridgeCallback<T>) {
    if (typeof params === 'function') {
      callback = params
      params = null
    }
    const isExist = checkFunction(funcName)
    const $native = window.HeZi
    if (onewayCallFuncName.includes(funcName)) {
      $native[funcName]()
      return
    }
    if (callback) {
      if (!isExist) {
        callback({ errMsg: `${funcName} does not exist in HeZi` })
        return
      }
      const responseCallbackId = bridge.genCallbackFunction(funcName, callback)
      if (params !== null) {
        $native[funcName](params, responseCallbackId)
      } else {
        $native[funcName](responseCallbackId)
      }
    } else {
      if (!isExist) return
      $native[funcName](params)
    }
  },
}

export default bridge